<template>
		<v-row justify-sm="center">
			<v-col cols="12">
				<v-toolbar color="elevation-0 round">


				<v-spacer><h2 class="name" v-html="bussiness.titleDE"></h2></v-spacer>
					<!-- <v-btn icon @click="toggleShowFeatured">
						<v-icon>mdi-star-circle</v-icon>
					</v-btn>-->
					<v-btn icon @click="toggleGridCategories">
						<v-icon>mdi-grid-large</v-icon>
					</v-btn>
				</v-toolbar>
				<hr>
			</v-col>

		</v-row>
</template>

<script>
	import { mapState, mapActions } from "vuex";
	export default {
		name: 'ToolBarHome',
		methods:{
			...mapActions(['changeGridCategories','changeShowFeatured']),
			toggleGridCategories(){

					const value = (this.gridCategories === 4 ) ? 6 : 4;
					this.$store.dispatch('changeGridCategories', value, { root: true })
			},
			toggleShowFeatured(){
				const value = !this.showFeatured;
					this.$store.dispatch('changeShowFeatured', value, { root: true })
			},
		},
		computed: {
			...mapState(['gridCategories','showFeatured','bussiness']),
		}

	}
</script>
